import React, { useState, useEffect } from "react";
import { Header } from "../../header";
import { NavigationTab } from "../../components/navigation-tab";
import { Box, Stack, CircularProgress } from "@mui/material";
import OpenPosition from "./open-position";
import ClosePosition from "./close-position";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/path";

const PositionListPage = () => {
  const [activeTabId, setActiveTabId] = useState(1);
  const [loading, setLoading] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCandidates();
  }, []);

  const fetchCandidates = async () => {
    try {
      const response = await axios.get(
        "https://api.a2ajobs.com/api/candidate-list"
      );

      setCandidates(response.data.data);
    } catch (error) {
      console.error("Error fetching candidates:", error);
    }
  };

  const navigationTabs = [
    { name: "open positions", id: 1 },
    { name: "close positions", id: 2 },
  ];

  const handleTabChange = (id) => {
    setActiveTabId(id);
  };

  const renderTabContent = () => {
    if (loading) return <CircularProgress />;
    return activeTabId === 1 ? (
      <OpenPosition candidates={candidates} />
    ) : (
      <ClosePosition candidates={candidates} />
    );
  };
  return (
    <>
      <Stack sx={{ py: { md: 3, xs: 0 }, mx: { md: 12, xs: 0 } }}>
        <Header
          title={"Positions"}
          actionButtonTitle={"Add Position"}
          onClickActionButton={() => navigate(paths.addPosition)}
        />
        <NavigationTab
          tabs={navigationTabs}
          activeTabId={activeTabId}
          activeTabName=""
          onTabChange={handleTabChange}
        />
        <Box overflow={"auto"}>
          <Stack>{renderTabContent()}</Stack>
        </Box>
      </Stack>
    </>
  );
};

export default PositionListPage;
